export const AMP_RUBICON_ID = 14682;

// prettier-ignore
export const AMP_RUBICON_SRID = {
  '/6782/AMP_GenAptTherapy/AmpPost/Sticky': '14682-amp-GenAptTherapy_Sticky',
  '/6782/AMP_GenAptTherapy/AmpPost/Recirc': '14682-amp-GenAptTherapy_Recirc',
  '/6782/AMP_GenAptTherapy/AmpPost': '14682-amp-GenAptTherapy_AmpPost',
  '/6782/AMP_GenAptTherapy/AmpPost/AmpPost_001': '14682-amp-GenAptTherapy_AmpPost_001',
  '/6782/AMP_GenAptTherapy/AmpPost/AmpPost_002': '14682-amp-GenAptTherapy_AmpPost_002',
  '/6782/AMP_GenAptTherapy/AmpPost/AmpPost_003': '14682-amp-GenAptTherapy_AmpPost_003',
  '/6782/AMP_GenAptTherapy/AmpPost/AmpPost_004': '14682-amp-GenAptTherapy_AmpPost_004',
  '/6782/AMP_GenAptTherapy/AmpPost/AmpPost_005': '14682-amp-GenAptTherapy_AmpPost_005',
  '/6782/AMP_GenAptTherapy/AmpPost/AmpPost_006': '14682-amp-GenAptTherapy_AmpPost_006',
  '/6782/AMP_GenAptTherapy/AmpPost/AmpPost_007': '14682-amp-GenAptTherapy_AmpPost_007',
  '/6782/AMP_GenAptTherapy/AmpPost/AmpPost_008': '14682-amp-GenAptTherapy_AmpPost_008',
  '/6782/AMP_GenAptTherapy/AmpPost/AmpPost_009': '14682-amp-GenAptTherapy_AmpPost_009',
  '/6782/AMP_GenAptTherapy/AmpPost/AmpPost_010': '14682-amp-GenAptTherapy_AmpPost_010',
  '/6782/AMP_GenAptTherapy/AmpPost/AmpPost_011': '14682-amp-GenAptTherapy_AmpPost_011',
  '/6782/AMP_GenAptTherapy/AmpPost/AmpPost_012': '14682-amp-GenAptTherapy_AmpPost_012',
  '/6782/AMP_GenAptTherapy/AmpGallery': '14682-amp-GenAptTherapy_AmpGallery',
  '/6782/AMP_GenAptTherapy/AmpGallery/AmpGallery_001': '14682-amp-GenAptTherapy_AmpGallery_001',
  '/6782/AMP_GenAptTherapy/AmpGallery/AmpGallery_002': '14682-amp-GenAptTherapy_AmpGallery_002',
  '/6782/AMP_GenAptTherapy/AmpGallery/AmpGallery_003': '14682-amp-GenAptTherapy_AmpGallery_003',
  '/6782/AMP_GenAptTherapy/AmpGallery/AmpGallery_004': '14682-amp-GenAptTherapy_AmpGallery_004',
  '/6782/AMP_GenAptTherapy/AmpGallery/AmpGallery_005': '14682-amp-GenAptTherapy_AmpGallery_005',
  '/6782/AMP_GenAptTherapy/AmpGallery/AmpGallery_006': '14682-amp-GenAptTherapy_AmpGallery_006',
  '/6782/AMP_GenAptTherapy/AmpGallery/AmpGallery_007': '14682-amp-GenAptTherapy_AmpGallery_007',
  '/6782/AMP_GenAptTherapy/AmpGallery/AmpGallery_008': '14682-amp-GenAptTherapy_AmpGallery_008',
  '/6782/AMP_GenAptTherapy/AmpGallery/AmpGallery_009': '14682-amp-GenAptTherapy_AmpGallery_009',
  '/6782/AMP_GenAptTherapy/AmpGallery/AmpGallery_010': '14682-amp-GenAptTherapy_AmpGallery_010',
  '/6782/AMP_GenAptTherapy/AmpGallery/AmpGallery_011': '14682-amp-GenAptTherapy_AmpGallery_011',
  '/6782/AMP_GenAptTherapy/AmpGallery/AmpGallery_012': '14682-amp-GenAptTherapy_AmpGallery_012'
};

export const CRITEO_NETWORK_ID = 7008;

export const TRIPLE_LIFT_DEFAULT_CODE = 'apartmenttherapy_leaderboard';

export const TRIPLE_LIFT_RAIL_CODE = 'apartmenttherapy_article_300x600';

export const TRIPLE_LIFT_STICKY_CODE = 'apartmenttherapy_320x50_sticky_hdx';

export const RUBICON_ACCOUNT_ID = '14682';

export const RUBICON_SITE_ID = '322896';

export const RUBICON_DEFAULT_ZONE_ID = '1681646';

export const CATEGORY_BIDS = {
  'dfp-category-001-0': {
    appNexusId: 14759905,
    gourmetAdsId: 14699781,
    ixId: { desktop: 479019, tablet: 479020, phone: 479021 }
  },
  'dfp-category-002-0': {
    appNexusId: 14759906,
    gourmetAdsId: 14700295,
    ixId: { desktop: 479022, tablet: 479023, phone: 479024 }
  },
  'dfp-category-003-0': {
    appNexusId: 14759907,
    gourmetAdsId: 14700596,
    ixId: { desktop: 479025, tablet: 479026, phone: 479027 }
  },
  'dfp-category-004-0': {
    appNexusId: 14759908,
    gourmetAdsId: 14700680,
    ixId: { desktop: 479028, tablet: 479029, phone: 479030 }
  },
  'dfp-category-005-0': {
    appNexusId: 14759909,
    gourmetAdsId: 14700685,
    ixId: { desktop: 479031, tablet: 479032, phone: 479033 }
  },
  'dfp-category-006-0': {
    appNexusId: 14759910,
    gourmetAdsId: 14701613,
    ixId: { desktop: 479034, tablet: 479035, phone: 479036 }
  },
  'dfp-category-007-0': {
    appNexusId: 14759911,
    gourmetAdsId: 14701634,
    ixId: { desktop: 479037, tablet: 479038, phone: 479039 }
  },
  'dfp-category-008-0': {
    appNexusId: 14759912,
    gourmetAdsId: 14701635,
    ixId: { desktop: 479040, tablet: 479041, phone: 479042 }
  },
  'dfp-category-009-0': {
    appNexusId: 14759913,
    gourmetAdsId: 14701636,
    ixId: { desktop: 479043, tablet: 479044, phone: 479045 }
  },
  'dfp-category-010-0': {
    appNexusId: 14759914,
    gourmetAdsId: 14701687,
    ixId: { desktop: 479046, tablet: 479047, phone: 479048 }
  },
  'dfp-category-011-0': {
    appNexusId: 14759915,
    gourmetAdsId: 14701688,
    ixId: { desktop: 479049, tablet: 479050, phone: 479051 }
  },
  'dfp-category-012-0': {
    appNexusId: 14759916,
    gourmetAdsId: 14701689,
    ixId: { desktop: 479052, tablet: 479053, phone: 479054 }
  }
};

export const COLLECTION_BIDS = {
  'dfp-collection-001-0': {
    appNexusId: 14759853,
    gourmetAdsId: 14701690,
    ixId: { desktop: 478983, tablet: 478984, phone: 478985 }
  },
  'dfp-collection-002-0': {
    appNexusId: 14759854,
    gourmetAdsId: 14701691,
    ixId: { desktop: 478986, tablet: 478987, phone: 478988 }
  },
  'dfp-collection-003-0': {
    appNexusId: 14759855,
    gourmetAdsId: 14701692,
    ixId: { desktop: 478989, tablet: 478990, phone: 478991 }
  },
  'dfp-collection-004-0': {
    appNexusId: 14759856,
    gourmetAdsId: 14701693,
    ixId: { desktop: 478992, tablet: 478993, phone: 478994 }
  },
  'dfp-collection-005-0': {
    appNexusId: 14759857,
    gourmetAdsId: 14701694,
    ixId: { desktop: 478995, tablet: 478996, phone: 478997 }
  },
  'dfp-collection-006-0': {
    appNexusId: 14759858,
    gourmetAdsId: 14701695,
    ixId: { desktop: 478998, tablet: 478999, phone: 479000 }
  },
  'dfp-collection-007-0': {
    appNexusId: 14759859,
    gourmetAdsId: 14701696,
    ixId: { desktop: 479001, tablet: 479002, phone: 479003 }
  },
  'dfp-collection-008-0': {
    appNexusId: 14759860,
    gourmetAdsId: 14701697,
    ixId: { desktop: 479004, tablet: 479005, phone: 479006 }
  },
  'dfp-collection-009-0': {
    appNexusId: 14759861,
    gourmetAdsId: 14701698,
    ixId: { desktop: 479007, tablet: 479008, phone: 479009 }
  },
  'dfp-collection-010-0': {
    appNexusId: 14759862,
    gourmetAdsId: 14701087,
    ixId: { desktop: 479010, tablet: 479011, phone: 479012 }
  },
  'dfp-collection-011-0': {
    appNexusId: 14759863,
    gourmetAdsId: 14701086,
    ixId: { desktop: 479013, tablet: 479014, phone: 479015 }
  },
  'dfp-collection-012-0': {
    appNexusId: 14759864,
    gourmetAdsId: 14701085,
    ixId: { desktop: 479016, tablet: 479017, phone: 479018 }
  }
};

export const HOME_BIDS = {
  'dfp-home-001-0': {
    appNexusId: 14759866,
    gourmetAdsId: 14700751,
    ixId: { desktop: 478947, tablet: 478948, phone: 478949 }
  },
  'dfp-home-002-0': {
    appNexusId: 14759867,
    gourmetAdsId: 14700747,
    ixId: { desktop: 478950, tablet: 478951, phone: 478952 }
  },
  'dfp-home-003-0': {
    appNexusId: 14759868,
    gourmetAdsId: 14700741,
    ixId: { desktop: 478953, tablet: 478954, phone: 478955 }
  },
  'dfp-home-004-0': {
    appNexusId: 14759869,
    gourmetAdsId: 14700718,
    ixId: { desktop: 478956, tablet: 478957, phone: 478958 }
  },
  'dfp-home-005-0': {
    appNexusId: 14759870,
    gourmetAdsId: 14700714,
    ixId: { desktop: 478959, tablet: 478960, phone: 478961 }
  },
  'dfp-home-006-0': {
    appNexusId: 14759871,
    gourmetAdsId: 14700710,
    ixId: { desktop: 478962, tablet: 478963, phone: 478964 }
  },
  'dfp-home-007-0': {
    appNexusId: 14759872,
    gourmetAdsId: 14700704,
    ixId: { desktop: 478965, tablet: 478966, phone: 478967 }
  },
  'dfp-home-008-0': {
    appNexusId: 14759873,
    gourmetAdsId: 14700699,
    ixId: { desktop: 478968, tablet: 478969, phone: 478970 }
  },
  'dfp-home-009-0': {
    appNexusId: 14759874,
    gourmetAdsId: 14700672,
    ixId: { desktop: 478971, tablet: 478972, phone: 478973 }
  },
  'dfp-home-010-0': {
    appNexusId: 14759875,
    gourmetAdsId: 14700670,
    ixId: { desktop: 478974, tablet: 478975, phone: 478976 }
  },
  'dfp-home-011-0': {
    appNexusId: 14759876,
    gourmetAdsId: 14700667,
    ixId: { desktop: 478977, tablet: 478978, phone: 478979 }
  },
  'dfp-home-012-0': {
    appNexusId: 14759877,
    gourmetAdsId: 14700661,
    ixId: { desktop: 478980, tablet: 478981, phone: 478982 }
  }
};

export const POST_BIDS = {
  'dfp-post-001-0': {
    appNexusId: 14759878,
    gourmetAdsId: 14700608,
    ixId: { desktop: 479055, tablet: 479056, phone: 479057 }
  },
  'dfp-post-002-0': {
    appNexusId: 14759879,
    gourmetAdsId: 14700607,
    ixId: { 'post-large': 479058, 'post-small': 479060 }
  },
  'dfp-post-003-0': {
    appNexusId: 14759880,
    gourmetAdsId: 14700606,
    ixId: { 'post-large': 479061, 'post-small': 479063 }
  },
  'dfp-post-004-0': {
    appNexusId: 14759881,
    gourmetAdsId: 14700604,
    ixId: { 'post-large': 479064, 'post-small': 479066 }
  },
  'dfp-post-005-0': {
    appNexusId: 14759882,
    gourmetAdsId: 14700602,
    ixId: { 'post-large': 479067, 'post-small': 479069 }
  },
  'dfp-post-006-0': {
    appNexusId: 14759883,
    gourmetAdsId: 14700601,
    ixId: { 'post-large': 479070, 'post-small': 479072 }
  },
  'dfp-post-007-0': {
    appNexusId: 14759884,
    gourmetAdsId: 14700577,
    ixId: { 'post-large': 479073, 'post-small': 479075 }
  },
  'dfp-post-008-0': {
    appNexusId: 14759885,
    gourmetAdsId: 14700568,
    ixId: { 'post-large': 479076, 'post-small': 479078 }
  },
  'dfp-post-009-0': {
    appNexusId: 14759886,
    gourmetAdsId: 14700564,
    ixId: { 'post-large': 479079, 'post-small': 479081 }
  },
  'dfp-post-010-0': {
    appNexusId: 14759887,
    gourmetAdsId: 14700526,
    ixId: { 'post-large': 479082, 'post-small': 479084 }
  },
  'dfp-post-011-0': {
    appNexusId: 14759888,
    gourmetAdsId: 14700518,
    ixId: { 'post-large': 479085, 'post-small': 479087 }
  },
  'dfp-post-012-0': {
    appNexusId: 14759889,
    gourmetAdsId: 14700513,
    ixId: { 'post-large': 479088, 'post-small': 479090 }
  },
  'dfp-right-rail-0': {
    appNexusId: 14759890,
    gourmetAdsId: 14700496,
    ixId: 479091,
    tripleLiftId: TRIPLE_LIFT_RAIL_CODE
  },
  'dfp-footer-0': {
    appNexusId: 14759891,
    gourmetAdsId: 14700487,
    ixId: { desktop: 479093, tablet: 479094, phone: 479094 } // Tablet and phone use the same id
  },
  'dfp-sticky-0': {
    appNexusId: 14759892,
    gourmetAdsId: 14700465,
    ixId: 479095,
    tripleLiftId: TRIPLE_LIFT_STICKY_CODE
  }
};

export const VIDEO_BIDS = {
  'jw-player-right-rail-1': {
    path: '/6782/GenAptTherapy/Video/Rail',
    appNexusId: 16695856,
    ixId: 459105
  },
  'jw-player-related-1': {
    path: '/6782/GenAptTherapy/Video/Related',
    appNexusId: 16695859,
    ixId: 459106
  },
  'jw-player-in-post-1': {
    path: '/6782/GenAptTherapy/Video/InPost',
    appNexusId: 16695865,
    ixId: 459107
  }
};

// TEMP: Galleries no longer includes ads
/*
export const GALLERY_BIDS = {
  'dfp-gallery-001-0': {
    appNexusId: 14759893,
    gourmetAdsId: 14700432,
    ixId: 334533
  },
  'dfp-gallery-002-0': {
    appNexusId: 14759894,
    gourmetAdsId: 14700418,
    ixId: 334534
  },
  'dfp-gallery-003-0': {
    appNexusId: 14759895,
    gourmetAdsId: 14700403,
    ixId: 334535
  },
  'dfp-gallery-004-0': {
    appNexusId: 14759896,
    gourmetAdsId: 14700383,
    ixId: 334536
  },
  'dfp-gallery-005-0': {
    appNexusId: 14759897,
    gourmetAdsId: 14700375,
    ixId: 334537
  },
  'dfp-gallery-006-0': {
    appNexusId: 14759898,
    gourmetAdsId: 14700365,
    ixId: 334538
  },
  'dfp-gallery-007-0': {
    appNexusId: 14759899,
    gourmetAdsId: 14700343,
    ixId: 334539
  },
  'dfp-gallery-008-0': {
    appNexusId: 14759900,
    gourmetAdsId: 14700340,
    ixId: 334540
  },
  'dfp-gallery-009-0': {
    appNexusId: 14759901,
    gourmetAdsId: 14700339,
    ixId: 334541
  },
  'dfp-gallery-010-0': {
    appNexusId: 14759902,
    gourmetAdsId: 14700333,
    ixId: 334542
  },
  'dfp-gallery-011-0': {
    appNexusId: 14759903,
    gourmetAdsId: 14700332,
    ixId: 334543
  },
  'dfp-gallery-012-0': {
    appNexusId: 14759904,
    gourmetAdsId: 14700314,
    ixId: 334544
  }
};
*/
